/**
 * Open an external link in a new tab or browser window.
 * Accounts for environment-specific limitations (e.g. Zoom client).
 * @param {string} url - URL to open
 * @story #7456; User Story 10368: AI widgets: add disclaimer and report functionality
 */
export async function openExternalLink(url: string) {
  if ((window as any).zoomSdk) {
    // Fallback for Zoom client: cannot open new tabs, open browser window instead
    try {
      await (window as any).zoomSdk.openUrl({ url })
    } catch (error) {
      window.open(url, '_blank')
    }
  } else {
    window.open(url, '_blank')
  }
}

/**
 * Open an external email (mailto:) link in a new tab or browser window.
 * Accounts for environment-specific limitations (e.g. Zoom client).
 * @param {string} email - email to open
 * @story User Story 10368: AI widgets: add disclaimer and report functionality
 */
export async function openExternalEmailLink(email: string) {
  if ((window as any).zoomSdk) {
    // Fallback for Zoom client: cannot open new tabs, open browser window instead
    try {
      await (window as any).zoomSdk.openUrl({
        url: `${window.origin}/mailto?number=${encodeURIComponent(email)}`,
      })
    } catch (error) {
      window.open(`mailto:${email}`, '_blank')
    }
  } else {
    window.open(`mailto:${email}`, '_blank')
  }
}
